
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPurpleStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 3.13c-.072.162-.106.32-.199.43-.211.25-.43.502-.684.707-.735.594-1.491 1.164-2.236 1.747-.604.473-1.214.941-1.73 1.512a6.544 6.544 0 0 0-.557.713c-.193.284-.198.584-.06.908.322.761.72 1.483 1.128 2.2 1.126 1.983 2.216 3.986 3.22 6.033.186.38.313.787.466 1.183.015.04.024.086.028.13.018.216-.082.34-.296.3a2.268 2.268 0 0 1-.678-.232 28.826 28.826 0 0 1-1.486-.908c-1.575-1.017-3.144-2.044-4.718-3.064-.637-.413-1.293-.794-2-1.084-.536-.22-1.09-.34-1.676-.29-.445.038-.856.18-1.253.37-.715.34-1.358.792-1.989 1.26-1.262.934-2.514 1.882-3.775 2.82-.272.202-.559.384-.844.567a1.736 1.736 0 0 1-.36.178c-.194.068-.326-.032-.297-.233.024-.164.074-.328.137-.483.332-.83.66-1.662 1.013-2.484.566-1.32 1.155-2.628 1.724-3.946.203-.471.377-.954.483-1.46.123-.587-.043-1.053-.55-1.38-.285-.184-.587-.34-.884-.505-.21-.117-.427-.225-.637-.343a2.935 2.935 0 0 1-.336-.219c-.338-.257-.32-.566.067-.74.44-.196.89-.37 1.346-.528.701-.242 1.412-.456 2.116-.691.262-.088.516-.199.774-.3a3.277 3.277 0 0 0 1.57-1.285c.378-.58.71-1.189 1.07-1.78.17-.28.344-.56.552-.814.118-.145.292-.263.466-.342.328-.149.563-.082.781.202.14.183.257.384.377.58.221.364.431.735.658 1.095.204.324.506.53.885.599.245.044.501.081.746.058.784-.076 1.567-.17 2.347-.279 1.222-.171 2.441-.37 3.665-.537.335-.045.68-.027 1.02-.015a.99.99 0 0 1 .407.114c.083.042.13.15.199.236Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3.12951C19.9276 3.29181 19.8937 3.44985 19.8011 3.55955C19.5898 3.80957 19.3712 4.06194 19.1172 4.2672C18.3819 4.86133 17.626 5.43091 16.8813 6.01383C16.2769 6.48694 15.6668 6.95534 15.1508 7.52581C14.9488 7.74935 14.7625 7.98983 14.5936 8.23884C14.4013 8.5225 14.3956 8.82266 14.5332 9.14704C14.8561 9.90808 15.2545 10.6296 15.6619 11.3471C16.7882 13.3304 17.8782 15.3328 18.8818 17.3797C19.0679 17.7594 19.1949 18.1673 19.3476 18.563C19.3633 18.6039 19.3719 18.6486 19.3756 18.6924C19.3939 18.9087 19.2936 19.0333 19.0804 18.9922C18.8471 18.9472 18.6069 18.8764 18.402 18.7608C17.8965 18.4759 17.4035 18.1681 16.9163 17.8533C15.3412 16.8356 13.7718 15.8094 12.1984 14.7893C11.5611 14.376 10.905 13.9948 10.1986 13.7054C9.66193 13.4856 9.10781 13.3644 8.52172 13.4147C8.07716 13.4528 7.66617 13.5955 7.26856 13.7846C6.55397 14.1246 5.91117 14.5772 5.28017 15.0443C4.01771 15.9792 2.76557 16.9275 1.50492 17.8646C1.23331 18.0666 0.946046 18.2489 0.660824 18.4321C0.54889 18.5039 0.426976 18.5664 0.301546 18.6103C0.107164 18.6781 -0.0252964 18.5778 0.00407636 18.3769C0.0280055 18.2126 0.0784722 18.0488 0.140507 17.894C0.473473 17.0638 0.80179 16.2316 1.15449 15.4096C1.7204 14.0909 2.30944 12.7817 2.87796 11.464C3.0813 10.9927 3.25493 10.5105 3.36096 10.0044C3.48424 9.41668 3.31798 8.95142 2.81048 8.62323C2.52639 8.4395 2.22382 8.28337 1.92748 8.11871C1.71665 8.00161 1.50027 7.89438 1.29024 7.77616C1.17377 7.71054 1.06002 7.63786 0.953871 7.5571C0.615914 7.30036 0.634626 6.99056 1.02112 6.81749C1.46035 6.62086 1.91149 6.44633 2.36694 6.28919C3.06814 6.04736 3.77898 5.83279 4.48268 5.59792C4.745 5.51032 4.99937 5.39905 5.25703 5.29765C5.9207 5.03665 6.44476 4.59775 6.82683 4.01258C7.20505 3.43325 7.53609 2.8242 7.89673 2.23343C8.06752 1.95369 8.24137 1.67215 8.44857 1.419C8.56697 1.27419 8.74139 1.15552 8.91468 1.0769C9.243 0.928053 9.47843 0.995239 9.69606 1.2789C9.83612 1.46151 9.95259 1.66251 10.0727 1.85936C10.2943 2.22311 10.504 2.59426 10.7313 2.95442C10.9355 3.27768 11.2374 3.48418 11.6155 3.55282C11.8606 3.59735 12.1173 3.63448 12.3624 3.61081C13.1462 3.53487 13.9287 3.44122 14.7085 3.33197C15.9314 3.16058 17.1503 2.96149 18.3738 2.79515C18.7086 2.74972 19.0543 2.76812 19.3941 2.77978C19.5322 2.7846 19.6785 2.82992 19.8014 2.89374C19.8838 2.93647 19.9315 3.04427 20 3.12951Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/purple-star.b10d0186f372abb2c10f761cb97628ce.svg"),
        {
          React: SvgPurpleStar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      